import { labRequestSampleStep } from "../../../shared/config/labRequestSampleSteps";
import {
  GET_LABREQUESTSAMPLE_FAIL,
  GET_LABREQUESTSAMPLE_SUCCESS,
  GET_LABREQUESTSAMPLES_FAIL,
  GET_LABREQUESTSAMPLES_SUCCESS,
  ADD_LABREQUESTSAMPLE_SUCCESS,
  ADD_LABREQUESTSAMPLE_FAIL,
  ADD_LABREQUESTSAMPLEPROCESS_SUCCESS,
  ADD_LABREQUESTSAMPLEPROCESS_FAIL,
  ADD_LABREQUESTSAMPLECONTROL_SUCCESS,
  UPDATE_LABREQUESTSAMPLE_SUCCESS,
  UPDATE_LABREQUESTSAMPLECHECK,
  UPDATE_LABREQUESTSAMPLE_FAIL,
  DELETE_LABREQUESTSAMPLE_SUCCESS,
  DELETE_LABREQUESTSAMPLE_FAIL,
  SET_STATE_LABREQUESTSAMPLE
} from "./actionTypes";

const INIT_STATE = {
  labRequestSamples: [],
  labRequestSample: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const labRequestSamples = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LABREQUESTSAMPLES_SUCCESS:
      return {
        ...state,
        labRequestSamples: action.payload.labRequestSamples.map(labRequestSample => {
          return { ...labRequestSample, checked: (labRequestSample?.step === labRequestSampleStep.sampleControl) ? true : false }
        }
        ),
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_LABREQUESTSAMPLE:
      return { ...state, loading: action.payload }

    case GET_LABREQUESTSAMPLES_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABREQUESTSAMPLEPROCESS_SUCCESS:
      return {
        ...state,
        labRequestSamples: state.labRequestSamples.map(labRequestSample => {
          return { ...labRequestSample, evaluationFlag: true }
        }
        ),
      };

    case ADD_LABREQUESTSAMPLECONTROL_SUCCESS:
      return {
        ...state,
        labRequestSamples: state.labRequestSamples.map(labRequestSample =>
          labRequestSample.id.toString() === action.payload.id.toString()
            ? { ...labRequestSample, step: labRequestSampleStep.sampleControl }
            : labRequestSample
        ),
      };

    case ADD_LABREQUESTSAMPLE_SUCCESS:
      return {
        ...state,
        labRequestSamples: [...state.labRequestSamples, { ...action.payload, checked: false }],
      };

    case ADD_LABREQUESTSAMPLEPROCESS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABREQUESTSAMPLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LABREQUESTSAMPLE_SUCCESS:
      return {
        ...state,
        labRequestSamples: state.labRequestSamples.map(labRequestSample =>
          labRequestSample.id.toString() === action.payload.id.toString()
            ? { ...action.payload, labRequestSample }
            : labRequestSample
        ),
      };

    case UPDATE_LABREQUESTSAMPLECHECK:
      return {
        ...state,
        labRequestSamples: state.labRequestSamples.map(labRequestSample =>
          labRequestSample.id.toString() === action.payload.id.toString()
            ? { ...labRequestSample, checked: action.payload.checked }
            : labRequestSample
        ),
      };

    case UPDATE_LABREQUESTSAMPLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LABREQUESTSAMPLE_SUCCESS:
      return {
        ...state,
        labRequestSamples: state.labRequestSamples.filter(
          labRequestSample => labRequestSample.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LABREQUESTSAMPLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABREQUESTSAMPLE_SUCCESS:
      return {
        ...state,
        labRequestSample: action.payload,
      };

    case GET_LABREQUESTSAMPLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labRequestSamples;
